export default "__VITE_ASSET__3c67838d__"